import { all } from "redux-saga/effects";
import { projectUpdateWatcher, projectViewWatcher } from "../../project-saga/projectView-saga";

export default function* projectDetailsRootSaga() {
  yield all([
    projectViewWatcher(),
    projectUpdateWatcher(),
  ]);
}
